import { Link } from 'react-router-dom';
import type { CareEvent } from '../api/workspace';
import { fmtDate } from '../lib/format';
import './EventRow.css';

const STATUS_LABEL: Record<string, string> = {
  pending: 'Awaiting response',
  confirmed: 'Confirmed',
  declined: 'Declined',
  cancelled: 'Cancelled',
};

export function EventRow({ event, youthName }: { event: CareEvent; youthName: string }) {
  return (
    <Link
      to={`/schedule/${event.id}`}
      state={{ event, youthName }}
      className="card evrow"
    >
      <div className="evrow__date">
        <span className="evrow__date-main">{fmtDate(event.date)}</span>
        {event.time && <span className="muted evrow__date-time">{event.time}</span>}
      </div>
      <div className="evrow__body">
        <div className="evrow__title">{event.title}</div>
        <div className="muted evrow__sub">
          {youthName}
          {event.location ? ` · ${event.location}` : ''}
        </div>
      </div>
      <span className={`evrow__status evrow__status--${event.status}`}>
        {STATUS_LABEL[event.status] ?? event.status}
      </span>
    </Link>
  );
}
